export default {
  setView: (state,store,count) => {
    state.collection.view = count;
    store.collection.view = count; //Persistent variable
    // console.log(store);
  },
  toggleSidebar:(state) => {
    state.products.sidebar_active = !state.products.sidebar_active;
  }
}